import createIcon from '../../createIcon';

/**
 * @component @name Luggage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgNkgxNVYzQzE1IDIuNDUgMTQuNTUgMiAxNCAySDEwQzkuNDUgMiA5IDIuNDUgOSAzVjZIN0M1LjkgNiA1IDYuOSA1IDhWMTlDNSAyMC4xIDUuOSAyMSA3IDIxQzcgMjEuNTUgNy40NSAyMiA4IDIyQzguNTUgMjIgOSAyMS41NSA5IDIxSDE1QzE1IDIxLjU1IDE1LjQ1IDIyIDE2IDIyQzE2LjU1IDIyIDE3IDIxLjU1IDE3IDIxQzE4LjEgMjEgMTkgMjAuMSAxOSAxOVY4QzE5IDYuOSAxOC4xIDYgMTcgNlpNOS41IDE4SDhWOUg5LjVWMThaTTEyLjc1IDE4SDExLjI1VjlIMTIuNzVWMThaTTEzLjUgNkgxMC41VjMuNUgxMy41VjZaTTE2IDE4SDE0LjVWOUgxNlYxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Luggage = createIcon('Luggage', [
  [
    'path',
    {
      d: 'M17 6H15V3C15 2.45 14.55 2 14 2H10C9.45 2 9 2.45 9 3V6H7C5.9 6 5 6.9 5 8V19C5 20.1 5.9 21 7 21C7 21.55 7.45 22 8 22C8.55 22 9 21.55 9 21H15C15 21.55 15.45 22 16 22C16.55 22 17 21.55 17 21C18.1 21 19 20.1 19 19V8C19 6.9 18.1 6 17 6ZM9.5 18H8V9H9.5V18ZM12.75 18H11.25V9H12.75V18ZM13.5 6H10.5V3.5H13.5V6ZM16 18H14.5V9H16V18Z',
      key: '1mmns5',
    },
  ],
]);

export default Luggage;
